<template>
  <div class="swiper-wrapper">
    <div class="swiper" v-if="notice && notice.length">
      <div class="horn">
        <img
          style="width: 18px; height: 18px; display: inline-block"
          src="https://static.service.z-trip.cn/resources/pic/1255379486966-7e26095b-23a7-478b-b31b-0dd8e6b5edfb.svg"
          alt=""
        />
      </div>
      <div style="flex: 1; overflow: hidden" v-if="notice.length > 0">
        <swipe vertical :autoplay="notice.length === 1 ? false : 2500">
          <swipe-item v-for="item in notice" :key="item.id" @click="toTopLine(item.id)">
            <div class="item-flex">
              <span>{{ item.title }}</span>
              <span>{{ item.createDate.slice(0, 10) }}</span>
            </div>
          </swipe-item>
        </swipe>
      </div>
    </div>
  </div>
</template>

<script>
import { buriedPoint } from '@home/lib/buriedPoint'
import Swipe from 'vant/es/swipe'
import SwipeItem from 'vant/es/swipe-item'
export default {
  props: ['notice'],
  components: { Swipe, SwipeItem },
  data() {
    return {
      SYS_NOTICE: $ZConfig.getVal('SYS_NOTICE') == 1
    }
  },
  methods: {
    toTopLine(id) {
      // 埋点事件
      buriedPoint('Button_Click_Notice')
      this.$router.push({ path: '/common/headLine', query: { id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper-wrapper {
  margin: 0.8rem 0;
  height: 2.1rem;
  background-color: #fff;
  border-radius: 0.4rem;
  box-shadow: 0px 0.1rem 1rem rgba(120, 154, 187, 0.2);
}
.swiper {
  display: flex;
  height: 2.1rem;
  line-height: 2.1rem;
  padding: 0 0.6rem;
  border-radius: 0.2rem;
  background-color: rgba(255, 255, 255, 0.2);
  .horn {
    font-size: 16px;
    margin-right: 0.5rem;
    i {
      color: #f8a128;
    }
  }
}
.item-flex {
  flex: 1;
  display: flex;
  justify-content: space-between;
  color: rgb(51, 51, 51);
  & > div:last-child {
    text-align: right;
  }
}
</style>
